// extracted by mini-css-extract-plugin
export var fadeInAnimation = "list-module--fadeInAnimation--4e6cb";
export var list = "list-module--list--2f52e";
export var listItem = "list-module--listItem--7b94b";
export var listTitle = "list-module--listTitle--33358";
export var oneColumn = "list-module--oneColumn--fce3b";
export var wrapper = "list-module--wrapper--8474f";